"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationRender = void 0;
var React = __importStar(require("react"));
var main_1 = require("../../main");
var localization_1 = require("@scuf/localization");
var NotificationRender = /** @class */ (function (_super) {
    __extends(NotificationRender, _super);
    function NotificationRender() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationRender.prototype.render = function () {
        var iconNameMap = {
            critical: 'badge-stop',
            important: 'badge-warning',
            information: 'badge-info',
            success: 'check'
        };
        var _a = this.props, severity = _a.severity, onCloseClick = _a.onCloseClick, onDetailsClick = _a.onDetailsClick, title = _a.title, tags = _a.tags, hasIcon = _a.hasIcon, children = _a.children, detailsText = _a.detailsText, datetime = _a.datetime, t = _a.t, lng = _a.lng, rest = __rest(_a, ["severity", "onCloseClick", "onDetailsClick", "title", "tags", "hasIcon", "children", "detailsText", "datetime", "t", "lng"]);
        var notificationTitle = title && React.createElement("span", { className: "title" }, title);
        var notificationTags = tags && React.createElement("span", { className: "tags" }, tags.map(function (tag) { return React.createElement(main_1.Badge, { className: "badge", color: "grey", key: tag, content: tag }); }));
        var closeIcon = onCloseClick && React.createElement(main_1.Icon, { root: "common", name: "close", exactSize: 16 });
        return (React.createElement("div", __assign({}, rest, { className: this.genClasses() }),
            hasIcon && Object.values(iconNameMap).includes(iconNameMap[severity]) && (React.createElement("div", { className: "icon" },
                React.createElement(main_1.Icon, { root: "common", name: iconNameMap[severity] }))),
            React.createElement("div", { className: "content" },
                React.createElement("div", { className: "content-top" },
                    notificationTitle &&
                        React.createElement("div", { className: "heading" }, notificationTitle),
                    datetime &&
                        React.createElement("div", { className: "datetime" }, datetime),
                    notificationTitle && closeIcon &&
                        React.createElement("div", { className: "close-wrapper", onClick: onCloseClick }, closeIcon)),
                React.createElement("div", { className: "message" },
                    React.createElement("div", null, children),
                    !notificationTitle && closeIcon &&
                        React.createElement("div", { className: "close-wrapper", onClick: onCloseClick }, closeIcon)),
                (notificationTags || onDetailsClick) &&
                    React.createElement("div", { className: "action-wrapper" },
                        notificationTags && notificationTags,
                        onDetailsClick && React.createElement("a", { className: "action", onClick: onDetailsClick }, detailsText ? detailsText : t('See details'))))));
    };
    NotificationRender.prototype.genClasses = function () {
        var classes = 'ui notification ';
        classes += this.props.severity;
        if (this.props.className) {
            classes += " " + this.props.className;
        }
        return classes;
    };
    return NotificationRender;
}(React.Component));
exports.NotificationRender = NotificationRender;
exports.default = localization_1.InjectLocalization(NotificationRender);
